var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgWorkout(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M4.23 5.82a2.41 2.41 0 100-4.82 2.41 2.41 0 000 4.82zM7.73 8.86l7.32-1.82c.4-.1.64-.51.54-.9a.735.735 0 00-.8-.55L3.21 6.94c-1.94.23-2.88 2.5-1.67 4.03l4.11 5.19a4.212 4.212 0 005.78.79l3.53-2.57c.15-.11.34-.12.5-.03l5.82 3.39c.42.24.95.14 1.25-.23a.976.976 0 00-.16-1.38l-5.62-4.41c-.8-.63-1.86-.8-2.82-.47l-3.65 1.28c-.17.06-.36 0-.47-.15L7.59 9.25a.263.263 0 01.15-.41l-.01.02z"
  })));
}

export default SvgWorkout;